import { connect } from 'react-redux';

import {
  clearPostcodeBanner, ensurePostcodeBanner, sendClosedPostcodeBannerNotification,
} from '[theme-lib]/apps/header/actions/postcodeBanner';
import { isUserLoggedIn } from 'lib/apps/user/helpers';
import PostcodeBanner from '../components/PostcodeBanner';

export default connect(state => {
  const { bannerId, bannerVersion, html, isHidden } = state.header.postcodeBanner;

  return {
    bannerId,
    bannerVersion,
    html,
    isHidden,
    isLoggedIn: isUserLoggedIn(state.user),
  };
}, {
  clearPostcodeBanner,
  ensurePostcodeBanner,
  sendClosedPostcodeBannerNotification,
})(PostcodeBanner);
